import { AfterViewChecked, Directive, ElementRef, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[mtgFitToParent]'
})
export class FitToParentDirective implements AfterViewChecked {
  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  @HostListener('window:resize')
  onWindowResize() {
    this.transform();
  }

  ngAfterViewChecked(): void {
    this.transform();
  }

  transform() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.elementRef.nativeElement.style.transform = null;
    const parentPosition = this.elementRef.nativeElement.parentNode.getBoundingClientRect();
    const parentStyles = window.getComputedStyle(this.elementRef.nativeElement.parentNode);
    parentPosition.width -= parseFloat(parentStyles.paddingLeft) + parseFloat(parentStyles.paddingRight);
    parentPosition.height -= parseFloat(parentStyles.paddingTop) + parseFloat(parentStyles.paddingBottom);
    const elementPosition = this.elementRef.nativeElement.getBoundingClientRect();
    if (elementPosition.width > parentPosition.width || elementPosition.height > parentPosition.height) {
      const scale = Math.min(parentPosition.width / elementPosition.width, parentPosition.height / elementPosition.height);
      this.elementRef.nativeElement.style.transform = `scale(${scale})`;
    }
  }
}
